var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChevronDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "#303030",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.26101 6.18726C4.57484 5.91692 5.0484 5.95217 5.31874 6.266L7.9964 9.36559L10.6819 6.25948C10.9528 5.94615 11.4265 5.91175 11.7398 6.18267C12.0531 6.45358 12.0875 6.9272 11.8166 7.24054L8.94162 10.5658C8.44249 11.1431 7.54708 11.1423 7.049 10.5641L4.18226 7.24499C3.91192 6.93116 3.94718 6.4576 4.26101 6.18726Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevronDown);
export default __webpack_public_path__ + "static/media/chevron-down.5e27fe0e.svg";
export { ForwardRef as ReactComponent };